import { Injectable } from '@angular/core';
import {PositionGps} from "../../classes/common/position-gps";
import {Partecipant} from "../../classes/common/partecipant";

@Injectable({
  providedIn: 'root'
})
export class DataHistoryService {

  startDate_date: any;
  stopDate_date: any;
  sel_vehicle: Partecipant;

  limit: number = 5000;
  history: PositionGps[];
  route: PositionGps[];
  summary: any;

  constructor() {}

  reset(){
    this.sel_vehicle = undefined;
    this.startDate_date = undefined;
    this.stopDate_date = undefined;
    this.history = undefined;
    this.route = undefined;
    this.summary = undefined;
  }

}
